import React, { useEffect, useState } from 'react';
import styles from './InterPlantAggregateAssignment.module.css';
import { useHistory } from 'react-router-dom';
import { BackButton } from '..';
import PropTypes from 'prop-types';
import EmergencyAgsnToolbar from '../EmergencyAgsnToolbar/EmergencyAgsnToolbar';
import Table from '../../components/Table/Table';
import {
  API_RESOURCE_URLS,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  DISPLAY_MESSAGES,
  DATE_FORMAT,
} from '../../constants';
import { withAllowedOperationsProvider } from '../../hocs';
import moment from 'moment';
import InterPlantAssignDateModal from '../InterPlantAssignDateModal/InterPlantAssignDateModal';
import { API } from '../../apis/api';
import { buildErrorMessage } from '../../apis/calls';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { downloadCsv } from '../../utils/utils';

const InterPlantAggregateAssignment = ({
  hasActiveEdits,
  setHasActiveEdits,
  aggregate,
  lastRefreshedDate,
  rowsDataForInterPlant,
  loadPlannedInterPlant,
  setinterPlantEdit,
}) => {
  const history = useHistory();
  const ROW_HEIGHT = 38;
  const [plant] = usePlantAndLinesStore().plantState;
  const [line] = usePlantAndLinesStore().lineState;
  const [plantOptions] = usePlantAndLinesStore().plantOptions
  const [isEAgsnAssignDateModalOpen, setIsEAgsnAssignDateModalOpen] = useState(
    false,
  );
  const [dateRange, setDateRange] = useState({
    startDate: moment().subtract(6, 'days'), // Default: 7 days (today - 6 days)
    endDate: moment().add(60, 'days'), // Default : 60 days  (today + 60 days)
    isShowingPrevious: false
  });

  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const isLucknowProlifePlant = plant?.label === 'Lucknow-Prolife'
  const labelName = isLucknowProlifePlant ? 'Parent' : 'Chassis'
  const parentName = isLucknowProlifePlant ? 'Parent' : 'VC'
  const fixedColumns = [
    {
      width: 170,
      title: 'Part NO.',
      field: 'materialNumber',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 240,
      title: 'Part Description',
      field: 'materialDescription',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 230,
      title: `Production Planned Date`,
      field: 'plannedProductionDate',
      enableSearch: true,
      enableFilter: true,
      render: (row) => {
        return row.plannedProductionDate
          ? moment(row.plannedProductionDate).format(
            DATE_FORMAT.DD_MM_YYYY
          )
          : "Null";
      },
    },
    {
      width: 240,
      title: 'Line Name',
      field: 'lineName',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 240,
      title: 'Destination',
      field: 'rootMaterialPlant',
      enableSearch: true,
      enableFilter: true,
      render: (rowData) => {
          const match = plantOptions.find(
            plant => plant.value === rowData.rootMaterialPlant
          );
          return match ? match.label : rowData.rootMaterialPlant;
      }
    },
  ];
  const optionalColumns = [
    {
      width: 230,
      title: "Chassis Production Planned Date",
      field: "rootMaterialPlannedProductionDate",
      enableSearch: true,
      enableFilter: true,
      render: (row) =>
        row.rootMaterialPlannedProductionDate
          ? moment(row.rootMaterialPlannedProductionDate).format("DD/MM/YYYY")
          : null,
    },
    {
      width: 200,
      title: 'Vc Alias',
      field: 'rootMaterialAlias',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 170,
      title: 'VC Material',
      field: 'rootMaterial',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 300,
      title: 'VC Material Description',
      field: 'rootMaterialDescription',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: 'ASN',
      field: 'rootMaterialAsn',
      enableSearch: true,
      enableFilter: true,
    }
  ].filter((c) => c);

  const { showError, showSuccess, showLoading, closePopUp } = usePopupManager();
  const openEAgsnAssignDateModal = () => setIsEAgsnAssignDateModalOpen(true);
  const closeEAgsnAssignDateModal = () => setIsEAgsnAssignDateModalOpen(false);

  const [eAgsnFilteredRows, setEAgsnFilteredRows] = useState([]);
  const handleAssignDate = filteredRows => {
    setEAgsnFilteredRows(filteredRows);
    openEAgsnAssignDateModal();
  };
  const checkIfSameAggregateLIneIsSelected = selectedRows => {
    if (selectedRows.length === 1) return true;
     if (selectedRows.length > 1) {
        const checkIfHaveSame = selectedRows.every(
          element => element.lineName === selectedRows[0].lineName
        );

        if (checkIfHaveSame) return true;
      }
    return false;
  };
  
  //Assign Date Submit 
  const handleConfirmedAssignDate = async (selectedRows, date) => {  
    try {
      const payload = selectedRows.map(({ id }) => ({
        id: id,
        date: date,
      }));
      showLoading();
      const response = await API.patch(
        API_RESOURCE_URLS.InterPlantAssignDate(
          plant.value,
          selectedRows[0].lineId,
        ),
        payload,
      );
      if (response) {
        loadPlannedInterPlant();
        closePopUp();
        showSuccess({
          contextText: `${DISPLAY_MESSAGES.GENERATE_InterPlantAggregateAssignment} for ${moment(
            date,
            DATE_FORMAT.ISO,
          ).format('DD-MMM-YYYY')}`,
        });
      }
    } catch (error) {
      console.error(buildErrorMessage(error));
      showError({
        contextText: `Failed to archive ASN`,
        error: error,
      });
    }
  }

  //Check Assign Date Criteria  
  const handleSubmitAssignDate = async (selectedRows, date) => {
    if (eAgsnFilteredRows?.length && new Date(date) > new Date(eAgsnFilteredRows[0].recommendedPlannedProductionDate)) {   
      setIsEAgsnAssignDateModalOpen(false); // close assign modal
      showError({
        contextText: "You can't select this date as it violates the inter plant lead time constraint.",
      });
    }else{
      handleConfirmedAssignDate(selectedRows, date);
    }
  };
  
  

  const handlePreviousClick = () => {
    setIsLoading(true);
    if (dateRange.isShowingPrevious) {
      setDateRange({
        startDate: moment().subtract(6, 'days'),
        endDate: moment().add(60, 'days'),
        isShowingPrevious: false
      });
    } else {
      setDateRange({
        startDate: moment(0),
        endDate: moment().subtract(7, 'days'),
        isShowingPrevious: true
      });
    }
    setIsLoading(false);
  };

  const contextualButtonProps = {
    className: styles.previousButton,
    text: 'PREVIOUS',
    label: 'Prev',
    handleClick: handlePreviousClick,
    isPreviousActive: dateRange.isShowingPrevious,
    disabled: isLoading || hasActiveEdits
  };

  const redirectToApplicationLandingPage = () => {
    history.push('/');
  };

  useEffect(() => {
    if (rowsDataForInterPlant.data) {
      const filtered = rowsDataForInterPlant.data.filter(row => {
        const dateStr = row.rootMaterialPlannedProductionDate
          ? row.rootMaterialPlannedProductionDate
          : row.parentCreatedAt?.split("T")[0]; // take only "YYYY-MM-DD"

        if (!dateStr) return false;

        const rowDate = moment(dateStr, "YYYY-MM-DD");
        return rowDate.isBetween(dateRange.startDate, dateRange.endDate, "day", "[]");
      });
      setFilteredData(filtered);
    }
  }, [rowsDataForInterPlant.data, dateRange]);

  const prepareJsonHeaderAndValueFormats = aggregatePartNames => {
    const vcAggregateHeaderAndValueFormats = aggregatePartNames.map(
      partName => ({
        label: partName + ' Status',
        value: row =>
          row.materialGroupClusters.filter(group => group.name === partName)[0]
            ?.materials[0]?.aggregateStatus || 'unavailable',
      }),
    );

    const vcHeaderAndValueFormats = [
      {
        label: 'ASN',
        value: row => row.parentAsn,
      },
      {
        label: 'Part Number',
        value: row => '="' + row.materialNumber + '"',
      },
      {
        label: 'VC Alias',
        value: row => row.rootMaterialAlias || '',
      },
      {
        label: 'Part Description',
        value: row => row.materialDescription,
      },
      {
        label: 'Requirement From',
        value: row => row.parentLineName,
      },
      {
        label: `${labelName} Planned Date`,
        value: row => moment(row.parentPlannedProductionDate).format('DD MMM YYYY'),
      },
      {
        label: 'Fulfillment From',
        value: row => row.lineName,
      },
    ].filter(c => c);

    return [...vcHeaderAndValueFormats, ...vcAggregateHeaderAndValueFormats];
  };

  const generateAndDownloadLineoutCsvReport = filteredData => {
    try {
      if (!rowsDataForInterPlant.loading) {
        const dateValue = moment().format(DATE_FORMAT.ISO);

        const jsonData = filteredData;

        const aggregatePartNames = [];

        const { parseAsync } = require('json2csv');
        const fields = prepareJsonHeaderAndValueFormats(aggregatePartNames);
        const opts = { fields };
        parseAsync(jsonData, opts)
          .then(csv => {
            const exportedFilename =
              'InterPlant_Aggregate_Assignment_' +
              plant.label +
              '_' +
              line.label +
              '_' +
              dateValue +
              '.csv';
            downloadCsv(csv, exportedFilename);
          })
          .catch(error =>
            console.error(
              'Failed to download eAgsn report, error:' +
              buildErrorMessage(error),
            ),
          );
      }
    } catch (error) {
      console.error(
        'Failed to download Emergency AgSN report, error:' + buildErrorMessage(error),
      );
    }
  };

  useEffect(() => {
    setinterPlantEdit(hasActiveEdits);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasActiveEdits]);
  return (
    <>
      <div className={styles.backButton}>
        <BackButton
          basePath={aggregate}
          action="Interplant Aggregate Assignment"
          handleClick={redirectToApplicationLandingPage}
        />
      </div>
      <EmergencyAgsnToolbar
        lastRefreshedDate={lastRefreshedDate}
        hasActiveEdits={hasActiveEdits}
        restrictNavigationDuringEditing
        contextualButtonProps={contextualButtonProps}
      />
      <div className={styles.tableView}>
        <Table
          columns={[...fixedColumns, ...optionalColumns]}
          defaultColumns={[...fixedColumns]}
          rowHeight={ROW_HEIGHT}
          rows={filteredData}
          setAsnCount={() => { }}
          isDataLoading={rowsDataForInterPlant.loading}
          primaryAction={{
            name: 'ASSIGN DATE',
            actionFn: filteredData => handleAssignDate(filteredData),
            authOperation: USER_OPERATIONS.UPDATE_AGGREGATE_PLAN_SEQUENCE,
            shouldEnable: selectedRows =>
              checkIfSameAggregateLIneIsSelected(selectedRows),
          }}
          secondaryActions={[
            {
              name: 'DOWNLOAD CSV',
              getFilteredData: true,
              authOperation: USER_OPERATIONS.GET_CHASSIS_PLAN_ASN,
              shouldEnable: () => rowsDataForInterPlant.data.length > 0,
              actionFn: filteredData =>
                generateAndDownloadLineoutCsvReport(filteredData),
            },
          ]}
          setHasActiveEdits={setHasActiveEdits}
        />
      </div>
      {isEAgsnAssignDateModalOpen ? (
        <InterPlantAssignDateModal
          open={isEAgsnAssignDateModalOpen}
          handleClose={closeEAgsnAssignDateModal}
          title="Assign Date"
          rowsData={eAgsnFilteredRows}
          lineBackgroundColor="#82C1A7"
          handleSubmit={handleSubmitAssignDate}
        />
      ) : null}
    </>
  );
};
InterPlantAggregateAssignment.propTypes = {
  hasActiveEdits: PropTypes.bool.isRequired,
  setHasActiveEdits: PropTypes.func.isRequired,
  aggregate: PropTypes.string.isRequired,
  lastRefreshedDate: PropTypes.objectOf(moment),
  rowsDataForInterPlant: PropTypes.arrayOf(
    PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      data: PropTypes.array.isRequired,
      filteredData: PropTypes.array.isRequired,
    }),
  ),
  loadPlannedInterPlant: PropTypes.func.isRequired,
  setinterPlantEdit: PropTypes.func.isRequired,
};
export default withAllowedOperationsProvider(
  InterPlantAggregateAssignment,
  true,
  RESOURCE_TYPE.MATERIAL,
);
